import { colors, theme } from '@zonofi/common';
import { StyleSheet } from 'react-native';

export const chatStyles = StyleSheet.create({
  fontSemiBold20Primary: {
    ...theme.fontConfig.semiBold,
    fontSize: 20,
    color: theme.text.primary,
  },
  fontSemiBold16Primary: {
    ...theme.fontConfig.semiBold,
    fontSize: 16,
    color: theme.text.primary,
  },
  fontSemiBold18Primary: {
    ...theme.fontConfig.semiBold,
    fontSize: 18,
    color: theme.text.primary,
  },
  fontSemiBold14Primary: {
    ...theme.fontConfig.semiBold,
    fontSize: 14,
    color: theme.text.primary,
  },
  fontSemiBold12Primary: {
    ...theme.fontConfig.semiBold,
    fontSize: 12,
    color: theme.text.primary,
  },
  fontSemiBold12: { ...theme.fontConfig.semiBold, fontSize: 12 },
  fontRegular12: { ...theme.fontConfig.regular, fontSize: 12 },
  fontRegular10: { ...theme.fontConfig.regular, fontSize: 10 },
  fontRegular14: { ...theme.fontConfig.regular, fontSize: 14 },
  fontSemiBold16: { ...theme.fontConfig.semiBold, fontSize: 16 },
  fontSemiBold16Secondary: {
    ...theme.fontConfig.semiBold,
    fontSize: 16,
    color: theme.text.secondary,
  },
  fontSemiBold16Highlight: {
    ...theme.fontConfig.semiBold,
    fontSize: 16,
    color: theme.text.highlight,
  },
  fontSemiBold12Secondary: {
    ...theme.fontConfig.semiBold,
    fontSize: 12,
    color: theme.text.secondary,
  },
  fontRegular14Secondary: {
    ...theme.fontConfig.regular,
    fontSize: 14,
    color: theme.text.secondary,
  },
  fontRegular14Primary: {
    ...theme.fontConfig.regular,
    fontSize: 14,
    color: theme.text.primary,
  },
  fontRegular16Primary: {
    ...theme.fontConfig.regular,
    fontSize: 16,
    color: theme.text.primary,
  },
  fontRegular18Primary: {
    ...theme.fontConfig.regular,
    fontSize: 18,
    color: theme.text.primary,
  },
  fontRegular16Secondary: {
    ...theme.fontConfig.regular,
    fontSize: 16,
    color: theme.text.secondary,
  },
  fontRegular12Secondary: {
    ...theme.fontConfig.regular,
    fontSize: 12,
    color: theme.text.secondary,
  },
  fontRegular10Secondary: {
    ...theme.fontConfig.regular,
    fontSize: 10,
    color: theme.text.secondary,
  },
  fontRegular10SecondaryItalic: {
    ...theme.fontConfig.regular,
    fontSize: 10,
    color: theme.text.secondary,
    fontStyle: 'italic',
  },
  fontSemiBold10Highlight: {
    ...theme.fontConfig.semiBold,
    fontSize: 10,
    color: theme.text.highlight,
  },
  fontSemiBold14Highlight: {
    ...theme.fontConfig.semiBold,
    fontSize: 14,
    color: theme.text.highlight,
  },
  fontRegular14Highlight: {
    ...theme.fontConfig.regular,
    fontSize: 14,
    color: theme.text.highlight,
  },
  fontMedium16Secondary: {
    ...theme.fontConfig.medium,
    fontSize: 16,
    color: theme.text.secondary,
  },
  fontMedium16Primary: {
    ...theme.fontConfig.medium,
    fontSize: 16,
    color: theme.text.primary,
  },
  fontMedium14Highlight: {
    ...theme.fontConfig.medium,
    fontSize: 14,
    color: theme.text.highlight,
  },
  fontMedium14Primary: {
    ...theme.fontConfig.medium,
    fontSize: 14,
    color: theme.text.primary,
  },
  fontMedium12Secondary: {
    ...theme.fontConfig.medium,
    fontSize: 12,
    color: theme.text.secondary,
  },
  fontRegular10Failure: {
    color: '#bd2d09',
    ...theme.fontConfig.regular,
    fontSize: 10,
  },
  fontRegular12Failure: {
    color: '#bd2d09',
    ...theme.fontConfig.regular,
    fontSize: 12,
  },
  fontSemiBold16White: {
    ...theme.fontConfig.semiBold,
    fontSize: 16,
    color: colors.white,
  },
});
